export default __webpack_public_path__ + "static/improve-quality-of-life-accomplishment-2e-dc958b1d7aa2d6782c88e715ed62c5ac.webp";